/**
** 基础数据--检查表模板
 */
<template>
	<div id="checklistTemp" class="jc-page">
		<div class="jc-panel jc-page-head">
			<div class="header-title">{{ headerTitle }}</div>
			<div class="header-operation">
				<el-form ref="form" :model="form">
					<el-form-item>
						<el-input v-model="form.name" placeholder="检查表名称"></el-input>
					</el-form-item>
					<el-form-item>
						<el-select clearable v-model="form.organType" placeholder="机构类型" @change="handleChange()">
							<el-option 
								v-for="item in organOptions" 
								:key="item.organization_type_id"
								:label="item.organization_type_name"
								:value="item.organization_type_id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-select :disabled="checkTreeEnable" clearable  v-model="form.level" placeholder="考察层级">
							<el-option 
							v-for="item in levelOptions"
							:key="item.investigation_level_id"
							:label="item.investigation_level_name"
							:value="item.investigation_level_id"></el-option>
						</el-select>	
					</el-form-item> 
						<!-- <el-form-item> -->
								<el-button class="button" @click="handleQuery">查询</el-button>
						<!-- </el-form-item>
						<el-form-item> -->
								<el-button class="button" @click="delSelect">删除</el-button>
						<!-- </el-form-item>
						<el-form-item> -->
								<el-button class="button" @click="dialogVisible = true">添加</el-button>
						<!-- </el-form-item> -->
				</el-form>
			</div>
		</div>
		<div class="jc-table-container jc-scroll-panel">
			<el-table
			ref="multipleTable"
			:data="allCheckList"
			tooltip-effect="dark"
			style="width: 100%"
			@selection-change="handleSelectionChange">
				<el-table-column type="selection" width="55"></el-table-column>
				<!-- <el-table-column type="index" label="序号" width="55"></el-table-column> -->
				<el-table-column label="检查表名称" width="200">
						<template slot-scope="scope">{{scope.row.checkup_subject_name}}</template>
				</el-table-column>
				<el-table-column label="机构类型" width="200">
						<template slot-scope="scope">{{scope.row.organization_type_name}}</template>
				</el-table-column>
				<el-table-column label="考察层级">
						<template slot-scope="scope">{{scope.row.investigation_level_name_string}}</template>
				</el-table-column>
				<el-table-column label="操作" width="100">
						<template slot-scope="scope">
								<el-button @click="handleEdit(scope.$index, scope.row)" type="text" size="small">编辑</el-button>
								<span>|</span>
								<el-button type="text" size="small" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
						</template>
				</el-table-column>
			</el-table>
			<el-pagination
				background
				style="text-align:right"
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page.sync="currentPage"
				:page-size="count"
				layout="total, prev, pager, next"
				:total="total"
				>
			</el-pagination>
		</div>
		

		<el-dialog title="添加检查表模板" :visible.sync="dialogVisible" class="dialog">
			<el-form ref="checklistForm" :model="checklistForm">
				<el-row>
					<el-col :span="12">
						<el-form-item label="检查表名称">
							<el-input v-model="checklistForm.name" placeholder="请输入检查表名称"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="机构类型">
                            <el-select clearable v-model="checklistForm.organType" placeholder="请选择机构类型" @change="handleChange()">
                                <el-option 
                                v-for="item in organOptions"
                                :key="item.organization_type_id"
                                :label="item.organization_type_name"
                                :value="item.organization_type_id"></el-option>
                            </el-select>
                        </el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="考察层级">
							<!-- <select-input :liData="liData" @change="change"></select-input> -->
							<!-- <el-select @change="levelChange()" v-model="checklistForm.level" placeholder="请选择考察层级">
								<el-option
									v-for="item in levelOptions"
									:key="item.value"
									:label="item.label"
									:value="item.value"
									>
								</el-option>
							</el-select>	 -->
							<el-cascader clearable
								v-model="checklistForm.level"
								:options="levelOptions"
								:props="{ multiple: true, checkStrictly: true,value:'investigation_level_id',label:'investigation_level_name'}"
								placeholder="请选择考察层级">
							</el-cascader>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
					<el-button @click="dialogVisible = false">取消</el-button>
					<el-button type="primary" @click="submit()">确定</el-button>
			</div>
		</el-dialog>
	</div>
	
</template>
<script>
import SelectInput from '../../../../components/selectInput.vue';
import {getCheckupSubjectList,deleteCheckupSubjectInfo,addCheckupSubjectInfo,getOrganizationTypeList,getInvestigationLevelList} from '@/apis/checklistTemp'
export default {
  name:"ChecklistTemp",
	data(){
		return {
			checkTreeEnable:true,
			headerTitle:"检查表模板",
			form:{
				name:"",
				organType:"",
				level:""
			}, // 头部右边-表单内容
			organOptions:[],// 机构类型选择
			levelOptions:[
				
			], // 考察层级选择
			tableData:[
				// {
				// 	name:'校园安全检查表',
				// 	level:'市县两级'
				// }
			],// 表格内容
			multipleSelection:[], // 表格选择
			dialogVisible:false, // 添加检查表模板-对话框显示标识
			checklistForm:{
				name:"",
				organType:"",
				level:""
			}, // 添加检查表模板对话框-表单内容
			liData:[
				{
					Id:1,
					name:'省',
					check:false
				},
				{
					Id:2,
					name:'市',
					check:false
				}
			],
			selectName:"", // 添加检查表模板对话框-表单内容选中的考察层级
			allCheckList: [], // 表格内容
			orgList: [],
			regionList: [],
			currentPage:1,// 当前页数
            count:10,//表格页数
            total:0,// 总条目数
		}
	},
	components:{
		SelectInput
	},
	mounted(){

		// 7-基础-获取机构类型
		this.getOrganTypeList();
		// 查询
		this.handleQuery();
		// this.getCheckList()
		// this.getRegionList()
		// this.getOrgList()
	},
	methods:{
		reload(){
			this.getOrganTypeList();
			this.handleQuery();
		},
		handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
			this.handleQuery();
        },
		// 表格多选
		handleSelectionChange(val){
			this.multipleSelection = val;
		},
		// 表格中点击"删除"
		handleDelete(index,row){
			this.$confirm('确定要删除该检查表吗?', '提示', {
          		confirmButtonText: '确定',
          		cancelButtonText: '取消',
          		type: 'warning'
        		}).then(() => {
          		console.log('删除',index,row);
				let ids = []
				ids.push(row.checkup_subject_id)
				this.deleteCheckObj(ids)
        		})
		},
		delSelect(){
			this.$confirm('确定要删除选中的所有检查表吗?', '提示', {
          		confirmButtonText: '确定',
          		cancelButtonText: '取消',
          		type: 'warning'
        		}).then(() => {
				let ids = []
				for(let i = 0; i < this.multipleSelection.length; i++ ){
					ids.push(this.multipleSelection[i].checkup_subject_id)
				}
				this.deleteCheckObj(ids)
        		})
		},
		// 点击表格中"编辑"
		handleEdit(index,row){
			console.log('编辑',index,row);
			this.$router.push({
				path: '/baseData/Edit',
				query: {   
                		currentObject: row.checkup_subject_id
            		}
			});
			
		},
		// levelChange(){
		// 	console.log('考察层级',this.checklistForm.level);
		// },
		// "考察层级"下拉多选传值展示
		change(msg){
			// this.selectName = msg;
			this.checklistForm.level = msg;
			console.log('层级',	this.checklistForm.level);
		},
		getCheckList(){
    			getCheckupSubjectList(this.listParam).then(res => {
      			console.log('检查表模板',res);
				 if(res.data.status === '1'){
					 this.allCheckList = res.data.data.checkup_subject_list
					 console.log('show data',this.allCheckList)
				 }
    			})
		},
		deleteCheckObj(idArray){
			this.$confirm('是否确定删除数据？', "提示").then(()=>{
				let delIds = {
				checkup_subject_id_list: idArray
			}
    			deleteCheckupSubjectInfo(delIds).then(res => {
				 if(res.data.status === '1'){
					 this.$message({
          				message: '删除成功！',
          				type: 'success'
        				});

					this.handleQuery()
				 }
    			})
			})
			
		},
		
		// 点击头部“查询”按钮(28-检查专题-获得检查专题列表)
		handleQuery(){
			let obj = {
				checkup_subject_name:this.form.name,
				organization_type_id:this.form.organType,
				investigation_level_id:this.form.level,
				pagination:{
					page:this.currentPage,
                    count:this.count
				}
			};
			getCheckupSubjectList(obj).then(res => {
				console.log('检查表列表',res);
				if(res.data.status === "1"){
					this.allCheckList = res.data.data.checkup_subject_list;
					this.count = res.data.data.paginated.count;
					this.total = parseInt(res.data.data.paginated.total);
					this.$message({
						message: '查询成功！',
						type: 'success'
					});
				}else {
					this.$message.error(`${res.data.msg}`);
				}
			})
		},
		// 点击“添加dialog”中“确定”按钮（30-检查专题-添加检查专题信息）
		submit(){
			let that = this
			let arr = [];
			this.checklistForm.level.forEach(item =>{
				arr.push(parseInt(item[0]))
			})
			
			let obj = {
				checkup_subject_name:this.checklistForm.name,
				organization_type_id:this.checklistForm.organType,
				investigation_level_id_list:arr
			};
			addCheckupSubjectInfo(obj).then(res => {
				console.log('添加检查表',res);
				if(res.data.status === "1"){
					that.reload()
					that.dialogVisible = false;
					that.$message({
						message: '添加成功！',
						type: 'success'
					});
				}else{
					that.$message.error(`${res.data.msg}`);
				}
			})
		},
		// 7-基础-获取机构类型
        getOrganTypeList(){
            // 构造参数
            getOrganizationTypeList().then(res =>{
                console.log('获取机构类型',res.data.data);
                this.organOptions=res.data.data.organization_type_list;
                console.log('organOptions',this.organOptions);
            })
        },
		 // 34-基础-获得考察层级列表
		  handleChange(){
			this.checkTreeEnable = this.form.organType.length > 0 ? false:true
            console.log('机构类型',this.form.organType);
			let obj = null;
			if(this.dialogVisible === true){
				obj = {
					organization_type_id:this.checklistForm.organType
				}
			}else {
				obj = {
                	organization_type_id:this.form.organType
				}
			}
            getInvestigationLevelList(obj).then(res => {
                console.log('考察层级',res);
                this.levelOptions = res.data.data.investigation_level_list
            })
        },
		// handleTypeChangeDialog(){
		// 	let obj = {
		// 		organization_type_id:this.checklistForm.type
		// 	}
		// 	 let paramData = {
        //         device_type:10,
        //         user_id:this.user_id,
        //         token:this.token,
        //         jsonText:JSON.stringify(obj)
        //     };
        //     this.$instance.post('Base/Checkup/getInvestigationLevelList',paramData).then(res => {
        //         console.log('考察层级',res);
        //         this.levelOptions = res.data.data.investigation_level_list
        //     })
		// },
	}
}
</script>
<style scoped>
#checklistTemp{
    position: relative;
}
.header {
    width: 100%;
    height: 35px !important;
    border-bottom: 1px solid #ccc;
}
.header-left {
    width: 200px;
    text-align: left;
    position: absolute;
}
.header-title {
    font-weight: bold;
}
.header-right {
    position: absolute;
    right: 20px;
    /* width: 30%; */
    height: 35px;
    top: -15px;
}
.el-form{
    display: flex;
    height: 35px;
}
.el-form-item {
    width: 180px;
    margin-right: 10px;
}
.button {
    height: 38px;
    color: #fff;
    background-color: #000;
}
#checklistTemp >>> .el-input__inner {
    height: 35px;
    padding: 0 10px;
    border: 1px solid #000;
}
#checklistTemp >>> .el-input input::-webkit-input-placeholder{
    color: #9e9fa3;
}
/* 表格样式修改 */
.el-table{
    color: #000;
}
#checklistTemp >>> .el-table thead{
    color:#000;
    font-weight: unset;
}
#checklistTemp >>> .el-table__header{
    width: 100%;
   
}
#checklistTemp >>> .el-table th.el-table__cell{
    background-color: #f3f3f3;
}
/* #organlist >>> .el-table tr{
    
} */
#checklistTemp >>> .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
    border-bottom: unset;
}
.el-button--text{
    color: #000;
    font-size: 13px;
}
.el-table__row>td{
    border: none;
}
.el-table::before{
    height: 0px;
}
#checklistTemp >>> .el-checkbox__inner{
    width: 16px;
    height: 16px;
    border: 1px solid #9e9fa3;
}
/* 对话框样式修改 */
#checklistTemp >>> .dialog .el-dialog{
	width: 40%;
}
#checklistTemp >>> .dialog .el-dialog__header{
    text-align: left;
}
#checklistTemp >>> .dialog .el-dialog__title{
    font-size: 20px; 
}
#checklistTemp >>> .dialog .el-dialog__body{
    padding: 10px 20px;
    color: #000;
}
#checklistTemp >>> .dialog .el-dialog__body .el-form{
    width: 100%;
    height: 100%;
    display: block;
}
#checklistTemp >>> .dialog .el-dialog__body .el-form-item {
    width: 85%;
    margin-bottom: 15px;
}
#checklistTemp >>> .dialog .el-form-item__label{
    color: #000;
    font-size: 16px;
    text-align: left;
    line-height: 35px;
}
#checklistTemp >>> .dialog .el-input__inner {
    border: 1px solid #409eff;
    color: #000;
}
#checklistTemp >>> .dialog .el-select {
    width: 100%;
}
#checklistTemp >>> .dialog .el-dialog__footer {
    padding: 0px 20px 20px;
}
.dialog .el-cascader {
	width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/backStage/children/ChecklistTemp/ChecklistTemp.vue